document.addEventListener("teeinblue-event-component-injected", () => {
  setTimeout(() => {
    moveElementAfter('div[id*="estimated_delivery"]', ".tee-product-price");
  }, 2000);
});
const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};
